import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import classNames from 'classnames'

import { toCssClass } from 'helpers'
import {
    isTodayDay,
    isTomorrowDay,
} from 'helpers/datetime'
import {
    getAvailablePeripheries,
    getPeripheriesList,
} from 'helpers/peripheries'
import { NEGATIVE_IR_BALANCE_HINT } from 'helpers/i18n'

import Warning from 'components/Warning/Warning'
import { BattleTitle, Schedule, Status } from '../../components'

import { UNIT_TYPES } from 'constants'

import {
    UNAVAILABLE_BATTLE_AVAILABLE_SERVERS,
    UNAVAILABLE_BATTLE_FOOTER_MESSAGE,
    UNAVAILABLE_CURRENT_PERIPHERY_MESSAGES,
    UNAVAILABLE_BATTLE_FINE_WARNING,
    UNAVAILABLE_BATTLE_FINE_CONDITIONS,
    UNAVAILABLE_BATTLE_MESSAGES_TODAY,
    UNAVAILABLE_BATTLE_MESSAGES_TOMORROW,
} from './constants'

import styles from './UnavailableBattle.scss'

const UnavailableBattle = (props) => {
    const availablePeripheries = getAvailablePeripheries(props.peripheries, props.type)

    const isPeripheriesAvailable = props.peripheries.length > 0

    let warning = UNAVAILABLE_CURRENT_PERIPHERY_MESSAGES[props.type]
    let contentComponent
    let footerComponent
    let status

    if (props.isFine) {
        warning = UNAVAILABLE_BATTLE_FINE_WARNING
        status = (
            <Status
                primetimeStart={props.primetimeStart}
                type={props.type}
                isAvailable
            />
        )
        contentComponent = (
            <div className={styles.information}>
                {UNAVAILABLE_BATTLE_FINE_CONDITIONS}
            </div>
        )
        footerComponent = (
            <div className={styles.footer}>
                {NEGATIVE_IR_BALANCE_HINT}
            </div>
        )
    } else if (isPeripheriesAvailable) {

        const isAvailableOnCurrentPeriphery = props.peripheryName !== null
        const startTime = moment(props.primetimeStart)

        if (isAvailableOnCurrentPeriphery) {
            if (isTodayDay(startTime)) {
                warning = UNAVAILABLE_BATTLE_MESSAGES_TODAY(props.peripheryName, startTime.format('LT'))[props.type]
            } else if (isTomorrowDay(startTime)) {
                warning = UNAVAILABLE_BATTLE_MESSAGES_TOMORROW(props.peripheryName, startTime.format('LT'))[props.type]
            }
        }

        const isAvailableOnAnyPeriphery = availablePeripheries.length > 0
        if (isAvailableOnAnyPeriphery) {
            const peripheriesList = getPeripheriesList(availablePeripheries)

            contentComponent = (
                <div className={styles.information}>
                    <p className={styles.peripheries}>
                        {UNAVAILABLE_BATTLE_AVAILABLE_SERVERS[props.type]}
                        <br/>
                        <span className={styles.servers}>
                            {peripheriesList}
                        </span>
                    </p>
                </div>
            )
            footerComponent = (
                <div className={styles.footer}>
                    {UNAVAILABLE_BATTLE_FOOTER_MESSAGE(<span className={styles.settings}/>)}
                </div>
            )
        } else {
            contentComponent = (
                <div className={styles.information}>
                    <Schedule
                        peripheries={props.peripheries}
                        type={props.type}
                    />
                </div>
            )
        }
    }

    const className = classNames(
        styles.base,
        styles[`base__${toCssClass(props.type)}`],
    )

    const messageClassName = classNames(styles.message, {
        [styles.message__unavailablePeripheries] : !isPeripheriesAvailable,
    })

    return (
        <div className={className}>
            <div className={styles.holder}>
                <div className={styles.header}>
                    <BattleTitle type={props.type} />
                </div>
                {status}
                <div className={messageClassName}>
                    <Warning type='warning'>
                        {warning}
                    </Warning>
                </div>
                {contentComponent}
                {footerComponent}
            </div>
        </div>
    )
}

UnavailableBattle.propTypes = {
    type: PropTypes.oneOf(Object.values(UNIT_TYPES)).isRequired,
    peripheries: PropTypes.array,
    peripheryName: PropTypes.string,
    primetimeStart: PropTypes.number,
    isFine: PropTypes.bool,
}

export default UnavailableBattle



// WEBPACK FOOTER //
// ./components/BattleWizard/components/UnavailableBattle/UnavailableBattle.jsx